import { render, staticRenderFns } from "./workAssignments-detail.vue?vue&type=template&id=8754679e&scoped=true"
import script from "./workAssignments-detail.vue?vue&type=script&lang=js"
export * from "./workAssignments-detail.vue?vue&type=script&lang=js"
import style0 from "./workAssignments-detail.vue?vue&type=style&index=0&id=8754679e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8754679e",
  null
  
)

export default component.exports